import React from 'react';
import Lottie from 'react-lottie';
import './Discount_Lottie.css';
import * as animationData from './Discount_Lottie.json';

function Discount_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Discount_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Discount_Lottie;